import { X, BarChart2, FileText, Building2, Heart, Moon, Newspaper, Bed, Sun, Home, Vote, Pill } from 'lucide-react'
import { Link } from 'react-router-dom'
import { SECTIONS } from './sections'

interface SideMenuProps {
  open: boolean
  onClose: () => void
  theme: 'dark' | 'light'
  onToggleTheme: () => void
}

const NEW_PATHS = new Set(['/referendum'])
const NEW_FARMACIE_PATHS = new Set(['/farmacie'])

const ICON_BY_PATH: Record<string, any> = {
  '/datidemografici': BarChart2,
  '/pianidizona': FileText,
  '/poloterritoriale': Building2,
  '/casedellacomunita': Heart,
  '/strutturesanitarie': Building2,
  '/farmacie': Pill,
  '/rsa': Bed,
  '/cdi': Sun,
  '/rsd': Building2,
  '/css': Home,
  '/cdd': Sun,
  '/news': Newspaper,
  '/referendum': Vote,
}

export default function SideMenu({ open, onClose, theme, onToggleTheme }: SideMenuProps) {
  return (
    <>
      {open && <div className="sidemenu-overlay" onClick={onClose} />}
      <nav className={`sidemenu ${open ? 'sidemenu--open' : ''}`}>
        <div className="sidemenu-header">
          <span className="sidemenu-title">Sezioni</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <button
              type="button"
              className="btn-info"
              onClick={onToggleTheme}
              title={theme === 'dark' ? 'Modalità chiara' : 'Modalità scura'}
            >
              {theme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
            </button>
            <button className="btn-info" onClick={onClose}><X size={16} /></button>
          </div>
        </div>
        <div className="sidemenu-links">
          {SECTIONS.map(s => {
            const Icon = ICON_BY_PATH[s.path]
            return (
              <Link key={s.path} to={s.path} className="sidemenu-link" onClick={onClose}>
                <Icon size={16} />
                <span>{s.label}</span>
                {NEW_PATHS.has(s.path) && (
                  <span style={{
                    marginLeft: 'auto',
                    fontSize: 9,
                    fontWeight: 700,
                    letterSpacing: '0.05em',
                    color: '#fff',
                    background: 'var(--accent)',
                    borderRadius: 4,
                    padding: '1px 5px',
                    flexShrink: 0,
                  }}>
                    NEW
                  </span>
                )}
                {NEW_FARMACIE_PATHS.has(s.path) && (
                  <span style={{
                    marginLeft: 'auto',
                    fontSize: 9,
                    fontWeight: 700,
                    letterSpacing: '0.05em',
                    color: '#fff',
                    background: '#059669',
                    borderRadius: 4,
                    padding: '1px 5px',
                    flexShrink: 0,
                  }}>
                    NEW
                  </span>
                )}
              </Link>
            )
          })}
        </div>
      </nav>
    </>
  )
}
